/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconBxsCube8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBxsCube8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.335 2.088 4 .666.668 2.088V6.09l3.333 1.243L7.335 6.09V2.088ZM4 3.274l-2.366-.882 2.366-1.031 2.367 1.031L4 3.274ZM1.356 5.67V2.966l2.301.858v2.703l-2.3-.858Zm2.99.858V3.824l2.3-.858V5.67l-2.3.858Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBxsCube12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBxsCube12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 3.133 6 1 1 3.133v6.003L6 11l5-1.864V3.133Zm-5 1.78L2.45 3.588 6 2.043l3.55 1.546L6 4.912ZM2.033 8.504V4.45l3.45 1.287V9.79l-3.45-1.286ZM6.516 9.79V5.737L9.967 4.45v4.055L6.517 9.79Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBxsCube16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBxsCube16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.665 4.178 8 1.334 1.332 4.178v8.004l6.667 2.485 6.666-2.485V4.178ZM8 6.551 3.266 4.786l4.733-2.062 4.732 2.062L8 6.551Zm-5.29 4.79V5.933L7.31 7.65v5.406L2.71 11.34Zm5.978 1.714V7.65l4.602-1.715v5.406l-4.602 1.715Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBxsCube24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBxsCube24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 6.266 12 2 2 6.266v12.006L12 22l10-3.727V6.266ZM12 9.825 4.901 7.179 12 4.085l7.099 3.094L12 9.825Zm-7.935 7.184V8.9l6.902 2.573v8.109l-6.902-2.573Zm8.968 2.573v-8.109L19.935 8.9v8.11l-6.902 2.572Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconBxsCube = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBxsCube(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconBxsCube8 {...iconProps} />;
        case '12':
            return <IconBxsCube12 {...iconProps} />;
        case '16':
            return <IconBxsCube16 {...iconProps} />;
        case '24':
            return <IconBxsCube24 {...iconProps} />;
        default:
            return <IconBxsCube24 {...iconProps} />;
    }
});
